import React, {useState} from "react";
import { connect } from "react-redux";
import clsx from "clsx";

import useStyles from "./styles";
import { Grid, Paper, Divider, IconButton, useMediaQuery, useTheme } from "@material-ui/core";

// components
import Title from "../../components/Wrappers/Title";
import AgentProgressSideBar from "./components/AgentSideBar/AgentProgressSideBar";
import CurrentCallInfo from "./components/AgentSideBar/CurrentCallInfo";
//import Notes from "./components/AgentSideBar/Notes";

import PreviewModeTab from "./components/Preview/PreviewModeTab";
import ProgressiveModeTab from "./components/Progressive/ProgressiveModeTab";

import Disposition from "./components/Disposition/Disposition";
import CallHandler from "./CallHandler";
// import BrowserNotification from "../../components/BrowserNotification/BrowserNotification";

import InfoIcon from '@material-ui/icons/Info';


function CallPanel(props) {
	var classes = useStyles();
	const [showGridOnMobile, setShowGridOnMobile] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleToggle = () => {
    setShowGridOnMobile(prev => !prev);
  };

  const shouldShowGrid = !isMobile || showGridOnMobile;


	const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
	//const fullfixedHeightPaper = clsx(classes.paper, classes.fullfixedHeight);
	const rightfixedHeightPaper = clsx(classes.paper, classes.rightfixedHeight)
	const [disconnectFromIconClick, setDisconnectFromIconClick] = useState(false);

//  useEffect(() => {
// 		if (
// 		  props.callType === "INBOUND" &&
// 		  props.callsInQueue > 0 &&
// 		  (props.agentState !== "INCALL" &&
// 		   props.agentState !== "CLOSURE" &&
// 		   props.agentState !== "PREVIEW_FAIL")
// 		) {
// 		  setShowBrowserNotification(true);
// 		} else {
// 		  setShowBrowserNotification(false);
// 		}
// 	  }, [props.agentState, props.callType, props.callsInQueue]);
	  
	return (
		<>
		    {/* {showBrowserNotification && <BrowserNotification />} */}
			<Grid container spacing={1} className={classes.MainCallingSection}>

				{
					shouldShowGrid && <Grid item xs={12} md={4} lg={3} className={classes.CurrCallInfoDiv}>
					<AgentProgressSideBar />
					<Grid container spacing={1} style={{height: "calc(100% - 53px)"}}>
						<Grid item xs={12} md={false} lg={false}>
							<Paper className={fixedHeightPaper}>
								<Title>Current Call Info </Title>
								<Divider />
								<CurrentCallInfo />
							</Paper>
						</Grid>
						{/*<Grid item xs={12} md={false} lg={false}>
							<Paper className={fullfixedHeightPaper}>
								<Notes />
							</Paper>
						</Grid>*/}
					</Grid>
				</Grid>
				}

				<Grid  key={props.sessionId} className={rightfixedHeightPaper} item xs={12} sm={12} md={8} lg={9}>
					{/* <BrowserNotification /> */}
					<CallHandler onDisconnectIconClick={() => setDisconnectFromIconClick(true)} />
					{props.agentState === "INCALL" || props.agentState === "CLOSURE" || props.agentState === "PREVIEW_FAIL" ? <Disposition  triggerDisconnect={disconnectFromIconClick}
  onDisconnectHandled={() => setDisconnectFromIconClick(false)} /> : ""}
					{props.agentState === "FREE" || props.agentState === "CALL_PROGRESS" ? props.mode === "PREVIEW" ? <PreviewModeTab /> : <ProgressiveModeTab /> : ""}
				</Grid>
			</Grid>

				{isMobile && (<IconButton className={classes.CallInfoIconBtn} onClick={handleToggle}>
					<InfoIcon style={{fontSize:"3rem"}}/>
				</IconButton>)
				}
		</>
	);
}

const mapStateToProps = (state) => {
	return {
		leadId: state.agentData.leadId,
		callsInQueue: state.agentData.callsInQueue,
		agentState: state.agentData.agentState,
		agentId: state.agentData.agentId,
		mode: state.agentData.dialerType,
		sessionId: state.agentData.sessionId,
		callType: state.agentData.callType
	};
};

export default connect(mapStateToProps)(CallPanel);
